define('settings',[
  'domReady!'
], function() {
  if (!Drupal) {
    return {};
  }
  return Drupal.settings;
});

